import {Injectable} from '@angular/core';

type WebStorageType = 'localStorage' | 'sessionStorage';

@Injectable({
  providedIn: 'root'
})
export class WebStorageService {

  private storage: Storage;

  private static serialize(data: any): string {
    return JSON.stringify(data);
  }

  private static unserialize(data: any): string {
    let storagedata;
    try {
      storagedata = JSON.parse(data);
    } catch (err) {
      storagedata = data;
    }
    return storagedata;
  }

  private init(webStorageType: WebStorageType): void {
    switch (webStorageType) {
      case 'localStorage':
        this.storage = localStorage;
        break;
      case 'sessionStorage':
        this.storage = sessionStorage;
        break;
    }
  }

  public setItem(key: string, data: any, webStorageType: WebStorageType = 'localStorage'): void {
    this.init(webStorageType);
    const serializedData = WebStorageService.serialize(data);
    this.storage.setItem(key, serializedData);
  }

  public getItem(key: string, webStorageType: WebStorageType = 'localStorage'): any {
    this.init(webStorageType);
    const data = this.storage.getItem(key);
    return WebStorageService.unserialize(data);
  }

  public getNumber(key: string, webStorageType: WebStorageType = 'localStorage'): number | null {
    const value: unknown = this.getItem(key, webStorageType);
    if (typeof value === 'number') {
      return value;
    }

    if (typeof webStorageType === 'string') {
      const parsed: number = Number(value);
      if (!isNaN(parsed)) {
        return parsed;
      }
    }

    return null;
  }

  public getObject<T>(storageKey: string): T | null {
    const value: unknown = this.getItem(storageKey);
    if (value && typeof value === 'object') {
      return value as T;
    }

    if (typeof storageKey === 'string') {
      try {
        return JSON.parse(storageKey);
      } catch {
        // Ignore JSON parse error
      }
    }

    return null;
  }

  public deleteItem(key: string, webStorageType: WebStorageType = 'localStorage'): void {
    this.init(webStorageType);
    this.storage.removeItem(key);
  }
}
